var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	13732: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(96540); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",
	},
	57733: {
		fallback: function() { return __webpack_require__.e(2513).then(function() { return function() { return __webpack_require__(32513); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",
	},
	8122: {
		fallback: function() { return Promise.all([__webpack_require__.e(6593), __webpack_require__.e(3732)]).then(function() { return function() { return __webpack_require__(40961); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",
	},
	1995: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(74848); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",
	},
	61535: {
		fallback: function() { return __webpack_require__.e(1040).then(function() { return function() { return __webpack_require__(27813); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.13.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "mobx",
	},
	10865: {
		fallback: function() { return Promise.all([__webpack_require__.e(8519), __webpack_require__.e(7884), __webpack_require__.e(6079), __webpack_require__.e(8122), __webpack_require__.e(1995), __webpack_require__.e(1226)]).then(function() { return function() { return __webpack_require__(86715); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/router",
	},
	28653: {
		fallback: function() { return __webpack_require__.e(5219).then(function() { return function() { return __webpack_require__(95219); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.10.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/css",
	},
	67886: {
		fallback: function() { return __webpack_require__.e(5219).then(function() { return function() { return __webpack_require__(95219); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.11.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/css",
	},
	72541: {
		fallback: function() { return Promise.all([__webpack_require__.e(1370), __webpack_require__.e(1535)]).then(function() { return function() { return __webpack_require__(31370); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.6.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "mobx-react",
	},
	99247: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(5338); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",
	},
	59390: {
		fallback: function() { return Promise.all([__webpack_require__.e(1554), __webpack_require__.e(5259), __webpack_require__.e(1895), __webpack_require__.e(5576), __webpack_require__.e(1535), __webpack_require__.e(9247)]).then(function() { return function() { return __webpack_require__(95576); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "*",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@amzn/rangoli-storefront-data-provider",
	},
	15408: {
		fallback: function() { return Promise.all([__webpack_require__.e(8519), __webpack_require__.e(1106), __webpack_require__.e(5362)]).then(function() { return function() { return __webpack_require__(91106); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.26",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	19268: {
		fallback: function() { return Promise.all([__webpack_require__.e(9965), __webpack_require__.e(4763)]).then(function() { return function() { return __webpack_require__(29965); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.26",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",
	},
	76440: {
		fallback: function() { return __webpack_require__.e(987).then(function() { return function() { return __webpack_require__(13368); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.26",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	},
	57572: {
		fallback: function() { return Promise.all([__webpack_require__.e(7843), __webpack_require__.e(7126)]).then(function() { return function() { return __webpack_require__(17843); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	16656: {
		fallback: function() { return __webpack_require__.e(5852).then(function() { return function() { return __webpack_require__(95852); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.13.5",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/cache",
	},
	97126: {
		fallback: function() { return __webpack_require__.e(5852).then(function() { return function() { return __webpack_require__(95852); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.14.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/cache",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"516": [
		15408,
		19268,
		76440
	],
	"865": [
		10865
	],
	"1535": [
		61535
	],
	"1995": [
		1995
	],
	"2178": [
		28653,
		67886,
		72541
	],
	"3015": [
		57572
	],
	"3732": [
		13732
	],
	"5219": [
		16656
	],
	"7126": [
		97126
	],
	"7733": [
		57733
	],
	"8122": [
		8122
	],
	"9247": [
		99247
	],
	"9390": [
		59390
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}